"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetMediaItemProducts = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _presentationHttp = require("@ori/presentation-http");
var _productBox = require("@ori/product-box");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _utils = require("./utils");
/* istanbul ignore file -- api */

const useGetMediaItemProducts = ({
  productCodes
}) => {
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    atpClusterId,
    customerTypeId,
    visitorSegment,
    loading: loadingSegmentationParameters
  } = (0, _presentationHttp.useUserSegmentationData)();
  const {
    data,
    error
  } = (0, _staticApiClientReact.useGetTenantApplicationsProductBox)(tenant, {
    lang: language,
    productCodes,
    atpClusterId: atpClusterId ?? undefined,
    customerTypeId: customerTypeId ?? undefined,
    visitorSegment: visitorSegment ?? undefined
  }, {
    swr: {
      enabled: (0, _utils.shouldFetchProductBoxes)(productCodes, loadingSegmentationParameters),
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  });
  const products = (0, _react.useMemo)(() => (data?.data?.products ? (0, _productBox.mapProductBoxesFromStaticApi)({
    data: data.data.products,
    isAnonymousUser
  }) : [] // Filter out duplicated products.
  ).filter((product, index, productsList) => productsList.findIndex(productFromList => productFromList.name === product.name) === index), [data?.data?.products, isAnonymousUser]);
  return {
    isLoading: data === undefined && error === undefined,
    products,
    isError: Boolean(error)
  };
};
exports.useGetMediaItemProducts = useGetMediaItemProducts;
